import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Zap } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
export function HeroSection() {
  return <section className="relative pt-14 pb-6 md:pt-20 md:pb-10 px-4 overflow-hidden bg-[#0d0d0d]" data-id="element-104">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_50%,_rgba(255,107,0,0.08),transparent_70%)]" style={{
      paddingTop: '0px',
      paddingBottom: '0px'
    }} data-id="element-105" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center text-center" data-id="element-107">
          <div className="inline-block px-3 py-1 bg-[#FF6B00]/10 border border-[#FF6B00]/30 rounded text-[#FF6B00] text-xs font-bold tracking-widest mb-3" style={{
          fontSize: '11px',
          paddingTop: '4px',
          paddingBottom: '4px',
          marginTop: '8px',
          marginBottom: '12px',
          marginLeft: '0px',
          marginRight: '0px'
        }} data-id="element-108">
            PRESENTAMOS LA COLECCIÓN MÁS COMPLETA DE
          </div>

          <h1 className="text-4xl md:text-6xl font-bold text-white leading-[0.95] mb-2 text-shadow-lg uppercase" style={{
          fontSize: '32px',
          marginTop: '2px'
        }} data-id="element-109">
            +600 PLANOS METÁLICOS DE{' '}
            <span className="text-[#FF6B00]" data-id="element-110">HERRERÍA</span>
          </h1>

          <h2 className="text-xl md:text-2xl text-white font-medium mb-3" style={{
          fontSize: '17px'
        }} data-id="element-111">
            Con Medidas Exactas Para Fabricar y Vender
          </h2>

          <p className="text-lg text-[#C0C0C0] mb-4 max-w-xl leading-relaxed" style={{
          fontSize: '17px',
          fontWeight: '500',
          color: '#ffffff'
        }} data-id="element-112">
            Construye proyectos de herreria profesionales en menos de 24
            horas... aunque nunca hayas soldado una sola pieza.
          </p>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mb-5 max-w-3xl mx-auto" data-id="element-113">
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#FF6B00] blur-[100px] opacity-20 pointer-events-none" data-id="element-114" />

          {/* Floating trust badges */}
          <div className="absolute -bottom-3 left-2 md:left-4 z-20 flex items-center gap-1.5 bg-[#FF6B00] text-white font-black text-xs md:text-sm px-3 py-1.5 md:px-4 md:py-2 rounded-full shadow-[0_4px_20px_rgba(255,107,0,0.5)] border border-[#FF8C00]/50 uppercase tracking-wide" data-id="element-115">
            <span className="text-sm md:text-base" data-id="element-116">📐</span>
            <span data-id="element-117">+600 Planos</span>
          </div>
          <div className="absolute -bottom-3 right-2 md:right-4 z-20 flex items-center gap-1.5 bg-[#111] text-[#22C55E] font-black text-xs md:text-sm px-3 py-1.5 md:px-4 md:py-2 rounded-full shadow-[0_4px_20px_rgba(0,0,0,0.6)] border border-[#22C55E]/30 uppercase tracking-wide" data-id="element-118">
            <span className="text-sm md:text-base" data-id="element-119">🛡️</span>
            <span data-id="element-120">120 Días de Garantía</span>
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/dHjdkFVq1CSwAqzQEJKpPD/ChatGPT_Image_11_feb_2026,_04_40_03_p.m..webp" alt="Sistema Maestro de Herrería — Planos listos para fabricar" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-121" />
        </motion.div>

        {/* CTA Area */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-col items-center text-center" data-id="element-122">
          <div className="flex items-center gap-2 mb-3 text-[#FFD700]" data-id="element-123">
            <div className="flex" data-id="element-124">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-current" data-id="element-125" />)}
            </div>
            <span className="text-white font-medium ml-2" data-id="element-126">4.9/5</span>
            <span className="text-gray-500 text-sm" data-id="element-127">
              — Clientes Satisfechos
            </span>
          </div>

          <div className="flex items-center gap-3 mb-3" data-id="element-128">
            <span className="text-gray-400 text-sm font-medium" data-id="element-129">
              Oferta Especial:
            </span>
            <span className="text-gray-400 line-through text-lg" data-id="element-130">
              <PriceDisplay amount={49.99} data-id="element-131" />
            </span>
            <span className="text-[#FF6B00] text-3xl font-bold" data-id="element-132">
              <PriceDisplay amount={16.99} data-id="element-133" />
            </span>
          </div>

          <CTAButton size="xl" className="w-full md:w-auto mb-2 text-sm md:text-xl" data-id="element-134">
            AGREGAR AL CARRITO
          </CTAButton>

          <p className="text-sm text-gray-400 mb-1" data-id="element-135">
            Acceso Inmediato a +600 Planos + 8 Bonos &gt;&gt;
          </p>

          <p className="text-xs text-gray-500 mb-2" data-id="element-136">
            Pago único. Sin cargos mensuales.
          </p>

          <p className="text-xs text-gray-600 italic" data-id="element-137">
            Me reservo el derecho de cerrar esta oferta en cualquier momento
            después del 25 de febrero de 2026.
          </p>
        </motion.div>
      </div>
    </section>;
}